<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    top="5vh"
    show-close
    width="95%"
    :title="$l('dialog_title_appendSku') || '追加亚马逊补货明细'"
    :close-on-click-modal="false"
    :modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :amzReplenishmentCode="amzReplenishmentCode"
      @checkbox-change="(data) => (checkedRows = data)"
      @close="close"
    />

    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge
        :value="checkedRowCount"
        :hidden="!checkedRowCount"
        :class="{ clearable: !!checkedRowCount }"
      >
        <el-button
          type="primary"
          size="small"
          class="ml-2"
          @click="confirm()"
          :disabled="!checkedRowCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
  },
  data() {
    return { checkedRows: [] }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async confirm() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('tips_appendEmpty') || '请选择需要追加亚马逊补货明细',
          type: 'warning',
        })
        return
      }
      const h = this.$createElement

      const confirm = await this.$confirm(
        h('div', null, [
          h(
            'p',
            null,
            this.$l('confirm_appendSku') ||
              '是否要将选择的SKU追加至当前补货单？ '
          ),
          h(
            'p',
            { style: 'color: red' },
            this.$l('confirm_appendSku_pour') ||
              '注：如果有已存在的SKU，会覆盖已填报的数据。'
          ),
        ]),
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const listAmzSkuStoreCode = this.checkedRows.map(
        (item) => item.amzSkuStoreCode
      )
      const params = {
        amzReplenishmentCode: this.amzReplenishmentCode,
        listAmzSkuStoreCode,
      }

      const res = await this.$api
        .ecomAmzReplenishmentDetailAppendApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_append_error') || '追加失败')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_append_ok') || '追加成功',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    close() {
      this.checkedRows = []
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
